import React, { useState } from 'react';
import Routes from 'routes';
import styled from 'styled-components';

import type SensorialAnalysisModel from 'productionOrders/models/SensorialAnalysis';
import type SampleModel from 'productionOrders/models/Sample';
import MarkForCupping from 'shared/MarkForCupping';
import { customFetch } from 'utils/fetch';

const PendingCuppingTable = styled.p`
  display: flex;
  flex-direction: column;
  line-height: 1.3;
`;

export interface SensorialAnalysisProps {
  sample: SampleModel;
  sensorialAnalysis?: SensorialAnalysisModel;
  cuppingSessionEnabled?: boolean;
}

function SensorialAnalysis({
  sample: { id, considered_for_cupping, current_roasting },
  sensorialAnalysis,
  cuppingSessionEnabled = false,
}: SensorialAnalysisProps) {
  const [consideredForCupping, setConsideredForCupping] =
    useState(considered_for_cupping);

  const onMarkForCuppingClickHandler = () => {
    if (consideredForCupping) {
      window.location.href = Routes.new_sensorial_analysis_path();
    } else {
      customFetch(Routes.mark_for_cupping_api_v1_sample_path(id)).then(() => {
        setConsideredForCupping(true);
      });
    }
  };

  if (sensorialAnalysis && !sensorialAnalysis.finalized) {
    return (
      <PendingCuppingTable>
        <span>{I18n.translate('decaf.quality_assurance.pending_cupping_table')}</span>

        {sensorialAnalysis.cuppingTableIdentifier && (
          <span>{sensorialAnalysis.cuppingTableIdentifier}</span>
        )}
      </PendingCuppingTable>
    );
  }

  if (sensorialAnalysis) {
    return (
      <div className={`status status--no-pointer status--${sensorialAnalysis.status}`}>
        <span>{sensorialAnalysis.text}</span>
        <svg className='icon'>
          <use xlinkHref={`#${sensorialAnalysis.icon}`} />
        </svg>
      </div>
    );
  } else {
    return (
      <MarkForCupping
        onClick={onMarkForCuppingClickHandler}
        consideredForCupping={consideredForCupping}
        disabled={!current_roasting.id}
        cuppingSessionEnabled={cuppingSessionEnabled}
      />
    );
  }
}

export default SensorialAnalysis;
